import { Component, OnInit, OnDestroy, ChangeDetectorRef, Renderer2, ElementRef } from "@angular/core";
import { LanguageService, BaseSiteService } from "@spartacus/core";
import { take } from "rxjs/operators";
import { ResourcesService } from "../resources.service";
import { event } from 'jquery';

@Component({
  selector: 'app-browse-by-topic',
  templateUrl: './browse-by-topic.component.html',
  styleUrls: ['./browse-by-topic.component.scss'],
})
export class BrowseByTopicComponent implements OnInit, OnDestroy {
  catalogTypes = [];
  list = [];
  selectedtype;
  catalogTypeSubscription: any;
  status: boolean;
  listenFunc: () => void;

  constructor(
    public service: ResourcesService,
    private readonly cd: ChangeDetectorRef,
    private readonly lang: LanguageService,
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef,
    private baseSiteService: BaseSiteService
  ) { }

  baseSiteId: string;
  ngOnInit() {
    localStorage.setItem('selectedCategoryType', 'mostpopular');
    this.lang.getActive().subscribe((res) => {
      this.baseSiteService.getActive().pipe(take(1)).subscribe(bs => this.baseSiteId = bs);
      this.getCatalogTypes(res, event);
    });

   

    this.listenFunc = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      const removeID = document.querySelectorAll('.clickClass');
      removeID.forEach((element) => {
        element.classList.remove('active');
      });
      if (event.target.getAttribute("id")) {
        const id = event.target.getAttribute("id");
        document.getElementById(id).className += ' active'
        localStorage.setItem('selectedCategory', id);
      }
    });

    //const selectedCategory = localStorage.getItem('selectedCategory');
    //   setTimeout(function() {
    //     document.getElementById('Most popular_0').className += ' active'
    //     // if(selectedCategory) {
    //     //   document.getElementById(selectedCategory).className += ' active'
    //     // } else {
    //     //   document.getElementById('Most popular_0').className += ' active'
    //     // }     
    // }, 1000);

  }

  getCatalogTypes(type, e?) {

    this.service.getCatalogs(this.baseSiteId);
    this.catalogTypeSubscription = this.service.catalogTypes$.subscribe(
      (res) => {
        if (res !== null) {
          this.catalogTypes = res.subcategories;
          setTimeout(function () {
            document.getElementById('Most popular_0').className += ' active'
          }, 100);
          this.cd.detectChanges();
          this.service.categoryTypeList.push(res.subcategories);
        }
      }
    );
  }

  ngOnDestroy() {
    localStorage.removeItem('selectedCategory');
    this.listenFunc();
    this.catalogTypeSubscription.unsubscribe();
  }

  getCatalogType(type) {
    this.service.getCatalogTypes(type);
    localStorage.setItem('selectedCategoryType', type);
  }
}